import { number } from 'prop-types';


export class DBTraceLog {    

    portalTypeID: number = 0;
    ldc: string = '';
    kmiUrlCode: string = '';
    issuingApOrderID: string = '';
    orderType: string = '';
    logReferenceID: string = '';
    logType: string = '';
    logMessage: string = '';
    deviceType: string = '';
    deviceOS: string = '';
    deviceBrowser: string = '';
    emailToList: string = '';
}

export enum LogType {
    Info = "Info",
    Error = "Error",
    Warning = "Warning"
}